module.exports = __webpack_public_path__ + "img/loginM.1bddb711.png";